"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.305 4.985C3.833 3.85 5.005 3 6.507 3h10.987c1.502 0 2.674.85 3.201 1.985.53 1.14.402 2.565-.647 3.631l-5.075 5.156a.58.58 0 0 0-.172.404v4.148c0 1.517-1.295 2.676-2.8 2.676-1.507 0-2.802-1.158-2.802-2.676v-4.148a.58.58 0 0 0-.171-.404L3.953 8.616c-1.05-1.066-1.178-2.49-.648-3.63m1.27.59c-.302.65-.236 1.438.375 2.06l5.075 5.155c.365.37.575.865.575 1.386v4.148c0 .665.586 1.276 1.4 1.276.815 0 1.401-.611 1.401-1.276v-4.148c0-.521.21-1.016.574-1.386l5.075-5.156c.611-.62.677-1.41.375-2.06-.304-.654-.99-1.174-1.931-1.174H6.507c-.942 0-1.628.52-1.932 1.175",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FilterIcon24.js.map